module.exports = __webpack_public_path__ + "img/service-process.2a2a4c6a.png";